export const API_URL = "https://calendar.dplab.biz"

export const ColorTheme = {
    primary: "#a6d0e4",
    secondary: "#f9ffea",
    warning: "#ffecda",
    danger: "#d4a5a5"
}
